import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from '@/js/libs/router';
import PrivateContent from './PrivateContent.js';
const PrivateRoute = (props) => (_jsx(PrivateContent, { ...props, children: _jsx(Outlet, {}) }));
export default React.memo(PrivateRoute);
